import React, { FunctionComponent, useState } from 'react'
import { FiUser } from 'react-icons/fi'
import Dialog from '@material-ui/core/Dialog'

import '../styles/Item.scss'
import { ContactsData } from '../utils/SearchItem'
import Icon from './Icon'
import MatchingTerms from './MatchingTerms'
import moment from 'moment'

const ContactsItem: FunctionComponent<ContactsData> = (props) => {
  const [open, toggleOpen] = useState(false)

  const renderPopup = () => {
    const date = moment(new Date(props.last_contact)).format('MMMM D, YYYY')

    return (
      <Dialog open={open} onClose={() => toggleOpen(false)}>
        <div className='Item-popup'>
          <div className='Item-popup-header'>
            <Icon icon={FiUser} backgroundColor='#fcecbe' />
            <p>{props.name}</p>
          </div>
          <div className='Item-popup-content'>
            <strong>
              <p>Company: </p>
            </strong>
            <p>{props.company}</p>
            <strong>
              <p>Email(s): </p>
            </strong>
            <ul>
              {props.emails.map((email) => (
                <li>{email}</li>
              ))}
            </ul>
            <strong>
              <p>Phone(s): </p>
            </strong>
            <ul>
              {props.phones.map((phone) => (
                <li>{phone}</li>
              ))}
            </ul>
            <strong>
              <p>Last Contacted: </p>
            </strong>
            <p>{date}</p>
          </div>
          <MatchingTerms
            backgroundColor='#fcecbe'
            terms={props.matching_terms}
          />
        </div>
      </Dialog>
    )
  }

  return (
    <>
      <div className='Item' onClick={() => toggleOpen(true)}>
        <Icon icon={FiUser} backgroundColor='#fcecbe' />
        <p>{props.name}</p>
      </div>
      {renderPopup()}
    </>
  )
}

export default ContactsItem
